module.exports = __webpack_public_path__ + "img/hammer.1106d557.svg";